import React from 'react';
import { InView } from 'react-intersection-observer';
import '../../../../styles/ServicesHero.css'; // Ensure this path is correct

const ServicesHero = () => {
  return (
    <section className="serviceshero-section-custom" role="banner" aria-labelledby="serviceshero-title">
      <div className="serviceshero-custom-content-container">
        <InView triggerOnce={true} threshold={0.1}>
          {({ inView, ref }) => (
            <header ref={ref} className={`serviceshero-custom-content ${inView ? 'animate' : ''}`}>
              <h1 id="serviceshero-title">Disaster Recovery as a Service</h1>
            </header>
          )}
        </InView>
      </div>
    </section>
  );
};

export default ServicesHero;
